import React from "react";
import { SignatureImageImproved } from "../../utils/SignatureImage";

export const GetTableSectionHeader = (title) => {
  return {
    heights: { header1: "70px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: title,
        colSpan: 12,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
    ],
  };
};

export const getTableSubSectionHeader = (type, groupTitle) => {
  switch (type) {
    case "checkbox":
      return {
        heights: { header1: "60px" },
        classes: { header2: "" },
        inlineData: true,
        columns: [
          {
            title: groupTitle === "BLUE CARD" ? groupTitle : "Check Items",
            colSpan: 10,

            centerAlign: true,
            className: "tbl-text-normal",
            accessor: "year",
            isTitleOnly: true,
          },

          {
            title: "Inspector Name",
            colSpan: 2,

            centerAlign: true,
            className: "tbl-text-normal",
            accessor: "year",
            isTitleOnly: true,
          },
        ],
      };
  }
  return null;
};
export const GetTableRowData = (title, id, type, item) => {
  switch (type) {
    case "checkbox":
      return {
        heights: { header1: "40px" },
        classes: { header2: "" },
        inlineData: true,
        columns: [
          {
            title: title,
            colSpan: 8,
            leftAlign: true,
            className: "tbl-text-normal",
            accessor: id,
            unBold: true,
            isTitleOnly: true,
          },
          {
            title: title,
            colSpan: 2,
            centerAlign: true,
            className: "tbl-text-normal",
            accessor: id,
            unBold: true,
            isValueOnly: true,
            formatter: (vals) => {
              return <span style={{ fontSize: "14px" }}>{typeof vals === "boolean" ? (vals ? "YES" : " ") : " "}</span>;
            },
          },
          {
            title: title,
            colSpan: 2,
            centerAlign: true,
            className: "tbl-text-normal",
            accessor: `${id}_filledBy`,
            unBold: true,
            isValueOnly: true,
          },
        ],
      };
    case "text":
    case "number":
      return item.fieldName !== "CERTIFIED BY"
        ? {
            heights: { header1: "40px" },
            classes: { header2: "" },
            inlineData: true,
            columns: [
              {
                title: title,
                colSpan: 2,
                leftAlign: true,
                className: "tbl-text-normal",
                accessor: id,
                isTitleOnly: true,
              },
              {
                title: title,
                colSpan: 2,
                leftAlign: true,
                className: "tbl-text-normal",
                accessor: id,
                unBold: true,
                isValueOnly: true,
                // formatter: (vals) => {
                //   return <div style={{ borderBottom: "1px solid black", paddingBottom: "4px", height: "100%", width: "100%" }}>{vals}</div>;
                // },
              },

              {
                title: "Inspector Name",
                colSpan: 2,
                leftAlign: true,
                className: "tbl-text-normal",
                accessor: "",
                isTitleOnly: true,
              },
              {
                title: "",
                colSpan: 2,
                leftAlign: true,
                className: "tbl-text-normal",
                accessor: `${id}_filledBy`,
                unBold: true,
                isValueOnly: true,
                // formatter: (vals) => {
                //   return <div style={{ borderBottom: "1px solid black", paddingBottom: "4px", height: "100%", width: "100%" }}>{vals}</div>;
                // },
              },
            ],
          }
        : {
            heights: { header1: "40px" },
            classes: { header2: "" },
            inlineData: true,
            columns: [
              {
                title: title,
                colSpan: 2,
                leftAlign: true,
                className: "tbl-text-normal",
                accessor: id,
                isTitleOnly: true,
              },
              {
                title: title,
                colSpan: 2,
                leftAlign: true,
                className: "tbl-text-normal",
                accessor: id,
                unBold: true,
                isValueOnly: true,
                // formatter: (vals) => {
                //   return <div style={{ borderBottom: "1px solid black", paddingBottom: "4px", height: "100%", width: "100%" }}>{vals}</div>;
                // },
              },
              {
                title: "spacer",
                colSpan: 4,
                accessor: "",
                isValueOnly: true,
              },
            ],
          };
    case "table": {
      let returnObject = {
        heights: { header1: "80px" },
        classes: { header2: "" },
        inlineData: false,
      };
      let cols = item.options.map((option) => {
        return {
          title: option.fieldName,
          colSpan: 1,
          className: "tabl-text-normal",
          accessor: option.id,
        };
      });
      return { ...returnObject, columns: [...cols] };
    }
  }
  return null;
};

export const certifiedBySchema = {
  heights: { header1: "50px" },
  classes: { header2: "" },
  inlineData: true,
  columns: [
    {
      accessor: "text28",
      title: "CERTIFIED BY",
      colSpan: 1,
      className: "tbl-text-normal",
    },
  ],
};
export const ImageSection = {
  heights: { header1: "50px" },
  classes: { header2: "" },
  inlineData: true,
  columns: [
    {
      title: "SIGNATURE OF GENERAL MANAGER",
      colSpan: 1,
      leftAlign: true,
      topAlign: true,
      rowSpan: 1,
      className: "tbl-text-normal",
      accessor: "signature",
      formatter: (value) => {
        return <SignatureImageImproved signatureImage={value} width={"550px"} />;
      },
    },
  ],
};
export const AllCheckItems = {
  0: {
    groupTitle: "CHANGE ALL FILTERS",
    items: [
      {
        id: "check",
        fieldName: "A: AIR COMPRESSOR SPIN-ON",
        fieldType: "checkbox",
      },
      {
        id: "check_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check1",
        fieldName: "B: AIR COMPRESSOR FILTER(S)",
        fieldType: "checkbox",
      },
      {
        id: "check1_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check2",
        fieldName: "C: FUEL OIL SPIN-ON FILTERS",
        fieldType: "checkbox",
      },
      {
        id: "check2_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check3",
        fieldName: "D: FUEL OIL SUCTION STRAINER ELEMENT & SEAL",
        fieldType: "checkbox",
      },
      {
        id: "check3_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check4",
        fieldName: "E: FUEL OIL PRIMARY FILTER & SEAL",
        fieldType: "checkbox",
      },
      {
        id: "check4_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check5",
        fieldName: "F: BLOWER OR TURBO INLET FILTERS",
        fieldType: "checkbox",
      },
      {
        id: "check5_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check6",
        fieldName: "G: ENGINE DOOR FILTERS",
        fieldType: "checkbox",
      },
      {
        id: "check6_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check7",
        fieldName: "H: LUBE OIL FILTERS",
        fieldType: "checkbox",
      },
      {
        id: "check7_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check8",
        fieldName: "I: ELECTRICAL CABINET FILTERS (368 day only)",
        fieldType: "checkbox",
      },
      {
        id: "check8_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check9",
        fieldName: "J: TURBO SOAK BACK FILTER",
        fieldType: "checkbox",
      },
      {
        id: "check9_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check10",
        fieldName: "K: TURBO OIL FILTER",
        fieldType: "checkbox",
      },
      {
        id: "check10_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  1: {
    groupTitle: "BRUSHES & FUSES",
    items: [
      {
        id: "check11",
        fieldName: "A: TRACTION MOTOR BRUSHES",
        fieldType: "checkbox",
      },
      {
        id: "check11_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check12",
        fieldName: "B: MAIN GENERATOR AND ALTERNATOR SLIP RING",
        fieldType: "checkbox",
      },
      {
        id: "check12_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check13",
        fieldName: "C: AUXILIARY GENERATOR",
        fieldType: "checkbox",
      },
      {
        id: "check13_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check14",
        fieldName: "D: FUEL PUMP",
        fieldType: "checkbox",
      },
      {
        id: "check14_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check15",
        fieldName: "E: LOAD REGULATOR",
        fieldType: "checkbox",
      },
      {
        id: "check15_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check16",
        fieldName: "F: CAB HEATER MOTORS",
        fieldType: "checkbox",
      },
      {
        id: "check16_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check17",
        fieldName: "G: CAB FANS",
        fieldType: "checkbox",
      },
      {
        id: "check17_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check18",
        fieldName: "H: DYNAMIC BRAKE FAN (IF EQUIPPED AND IN USE)",
        fieldType: "checkbox",
      },
      {
        id: "check18_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check19",
        fieldName: "I: SOAK BACK PUMP BRUSHES (IF EQUIPPED)",
        fieldType: "checkbox",
      },
      {
        id: "check19_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check20",
        fieldName: "J: INSPECT & REPLACE AR10 FUSES AS REQUIRED (IF EQUIPPED)",
        fieldType: "checkbox",
      },
      {
        id: "check20_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  2: {
    groupTitle: "SAFETY APPLIANCES",
    items: [
      {
        id: "check21",
        fieldName: "A: REPAIR AS NEC. (HANDHOLDS, GRAB IRONS, LADDERS, STEPS, & CUT LEVERS)",
        fieldType: "checkbox",
      },
      {
        id: "check21_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  3: {
    groupTitle: "BRAKE SHOES",
    items: [
      {
        id: "check22",
        fieldName: "A: REPLACE ANY WORN OR DEFECTIVE SHOES. ADJUST OVERLAP IF ANY SHOES ARE RIDING OFF THE EDGE OF THE RIM.",
        fieldType: "checkbox",
      },
      {
        id: "check22_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "text1",
        fieldName: "No. of shoes used:",
        fieldType: "text",
      },
      {
        id: "text1_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "text2",
        fieldName: "Type of shoe:",
        fieldType: "text",
      },
      {
        id: "text2_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  4: {
    groupTitle: "INSPECT TRUCKS",
    items: [
      {
        id: "check23",
        fieldName: "A: SPRINGS (COIL & ELLIPTICAL-CRACKS, BROKEN, OR MISALIGNED)",
        fieldType: "checkbox",
      },
      {
        id: "check23_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check24",
        fieldName: "B: CLEARANCE ON GEEP TRUCKS BETWEEN BOTTOM OF BOLSTER AND TOP OF SAFETY HANGER (MIN. 3/8'' CLEARANCE)",
        fieldType: "checkbox",
      },
      {
        id: "check24_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check25",
        fieldName: "C: SPRING HANGERS ON AAR TYPE SWITCHER TRUCKS",
        fieldType: "checkbox",
      },
      {
        id: "check25_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check26",
        fieldName: "D: SAFETY PINS ON AAR TYPE SWITCHER TRUCKS",
        fieldType: "checkbox",
      },
      {
        id: "check26_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check27",
        fieldName: "E: FRAME (FOR CRACKS OR DEFORMATION)",
        fieldType: "checkbox",
      },
      {
        id: "check27_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check28",
        fieldName: "F: HARDWARE (FOR LOOSE OR MISSING)",
        fieldType: "checkbox",
      },
      {
        id: "check28_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check29",
        fieldName: "G: BRAKE STRAPS AND HANGERS (FOR DAMAGED OR BENT)",
        fieldType: "checkbox",
      },
      {
        id: "check29_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check30",
        fieldName: "H: SUPPORT BEARING CAP BOLTS (FOR LOOSE OR MISSING)",
        fieldType: "checkbox",
      },
      {
        id: "check30_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check31",
        fieldName: "I: SAND HOSES, PIPES, AND NIPPLES (CONDITION & ALIGNMENT)",
        fieldType: "checkbox",
      },
      {
        id: "check31_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check32",
        fieldName: "J: INSIDE JOURNALS (LUBRICATE)",
        fieldType: "checkbox",
      },
      {
        id: "check32_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check33",
        fieldName: 'K: OUTSIDE JOURNALS (LUBRICATE-except those marked "No Field Lube")',
        fieldType: "checkbox",
      },
      {
        id: "check33_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check34",
        fieldName: "L: CENTER CASTINGS (LUBRICATE)",
        fieldType: "checkbox",
      },
      {
        id: "check34_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check35",
        fieldName: "M: CRATER BOX (ADD 1 OR 2 LBS GREASE AS REQUIRED)",
        fieldType: "checkbox",
      },
      {
        id: "check35_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  5: {
    groupTitle: "DRAFT GEAR",
    items: [
      {
        id: "check36",
        fieldName: "A: DAMAGE AND HARDWARE (LOOSE, WORN, OR MISSING)",
        fieldType: "checkbox",
      },
      {
        id: "check36_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check37",
        fieldName: "B: CHECK COUPLER WEAR AND CONTOUR",
        fieldType: "checkbox",
      },
      {
        id: "check37_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check38",
        fieldName: "C: LUBE COUPLER CARRIER WEAR PLATE",
        fieldType: "checkbox",
      },
      {
        id: "check38_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  6: {
    groupTitle: "HANDBRAKE",
    items: [
      {
        id: "check39",
        fieldName: "A: CHECK FOR PROPER OPERATION AND LUBRICATE AS REQUIRED. INSPECT, LUBE, & DATE ON 368 DAY INSP.",
        fieldType: "checkbox",
      },
      {
        id: "check39_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  7: {
    groupTitle: "INSPECT ALL BASE BOLTS",
    items: [
      {
        id: "check40",
        fieldName: "A: AIR COMPRESSOR",
        fieldType: "checkbox",
      },
      {
        id: "check40_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check41",
        fieldName: "B: EQUIPMENT RACK",
        fieldType: "checkbox",
      },
      {
        id: "check41_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check42",
        fieldName: "C: PRIME MOVER",
        fieldType: "checkbox",
      },
      {
        id: "check42_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check43",
        fieldName: "D: MAIN GENERATOR",
        fieldType: "checkbox",
      },
      {
        id: "check43_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check44",
        fieldName: "E: AUXILIARY GENERATOR",
        fieldType: "checkbox",
      },
      {
        id: "check44_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  8: {
    groupTitle: "BATTERIES",
    items: [
      {
        id: "check45",
        fieldName: "A: CHECK WATER LEVEL AND ADD AS REQUIRED",
        fieldType: "checkbox",
      },
      {
        id: "check45_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check46",
        fieldName: "B: CHECK BATTERIES FOR LOOSE CONNECTIONS",
        fieldType: "checkbox",
      },
      {
        id: "check46_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check47",
        fieldName: "C: CLEAN TERMINALS AS REQUIRED",
        fieldType: "checkbox",
      },
      {
        id: "check47_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check48",
        fieldName: "D: APPLY INSULATING VARNISH AS REQUIRED",
        fieldType: "checkbox",
      },
      {
        id: "check48_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check49",
        fieldName: "E: RINSE TOP OF BATTERIES",
        fieldType: "checkbox",
      },
      {
        id: "check49_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check50",
        fieldName: "F: LOAD TEST EACH INDIVIDUAL STARTING BATTERY FOR PROPER VOLTAGE, WHILE CRANKING THE ENGINE.",
        fieldType: "checkbox",
      },
      {
        id: "check50_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  9: {
    groupTitle: "CHECK FOR GROUNDS",
    items: [
      {
        id: "check51",
        fieldName: "A: HI-VOLTAGE (CONFIRM GROUND LIGHT WORKS IF EQUIPPED AND THAT THE ALARM BELL RINGS)",
        fieldType: "checkbox",
      },
      {
        id: "check51_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check52",
        fieldName: "B: LO-VOLTAGE (WHILE RUNNING AND DEAD)",
        fieldType: "checkbox",
      },
      {
        id: "check52_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  10: {
    groupTitle: "CHECK ALL LIGHTS FOR PROPER OPERATION (REPLACE OR REPAIR AS NECESSARY)",
    items: [
      {
        id: "check53",
        fieldName: "A: FRONT HEAD LIGHT (HI & LO)",
        fieldType: "checkbox",
      },
      {
        id: "check53_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check54",
        fieldName: "B: FRONT NUMBER BOARD",
        fieldType: "checkbox",
      },
      {
        id: "check54_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check55",
        fieldName: "C: FRONT CLASSIFICATION",
        fieldType: "checkbox",
      },
      {
        id: "check55_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check56",
        fieldName: "D: FRONT DITCH LIGHTS",
        fieldType: "checkbox",
      },
      {
        id: "check56_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check57",
        fieldName: "E: ENGINE ROOM LIGHTS",
        fieldType: "checkbox",
      },
      {
        id: "check57_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check58",
        fieldName: "F: CAB INTERIOR LIGHTS",
        fieldType: "checkbox",
      },
      {
        id: "check58_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check59",
        fieldName: "G: SPEEDOMETER LIGHTS",
        fieldType: "checkbox",
      },
      {
        id: "check59_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check60",
        fieldName: "H: PLATFORM LIGHTS",
        fieldType: "checkbox",
      },
      {
        id: "check60_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check61",
        fieldName: "I: REAR HEAD LIGHT (HI & LO)",
        fieldType: "checkbox",
      },
      {
        id: "check61_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check62",
        fieldName: "J: REAR NUMBER BOARD",
        fieldType: "checkbox",
      },
      {
        id: "check62_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check63",
        fieldName: "K: REAR CLASSIFICATION",
        fieldType: "checkbox",
      },
      {
        id: "check63_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check64",
        fieldName: "L: REAR DITCH LIGHTS",
        fieldType: "checkbox",
      },
      {
        id: "check64_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check65",
        fieldName: "M: GROUND LIGHTS",
        fieldType: "checkbox",
      },
      {
        id: "check65_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check66",
        fieldName: "N: GAUGE LIGHTS",
        fieldType: "checkbox",
      },
      {
        id: "check66_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check67",
        fieldName: "O: FUSE TEST LIGHT",
        fieldType: "checkbox",
      },
      {
        id: "check67_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  11: {
    groupTitle: "General Fields",
    items: [
      {
        id: "check68",
        fieldName: "A: EMPTY CAB TRASH RECEPTACLE. SWEEP AND ORGANIZE CAB AS NEC.",
        fieldType: "checkbox",
      },
      {
        id: "check68_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  12: {
    groupTitle: "PC SYSTEM",
    items: [
      {
        id: "check69",
        fieldName: "A: CHECK OPERATION & LIGHT - REPAIR AS NECESSARY",
        fieldType: "checkbox",
      },
      {
        id: "check69_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  13: {
    groupTitle: "ELECTRICAL CABINET",
    items: [
      {
        id: "check70",
        fieldName: "A: INSPECT WIRING AND COMPONENTS FOR CABINET VISUAL DAMAGE",
        fieldType: "checkbox",
      },
      {
        id: "check70_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  14: {
    groupTitle: "AIR OPERATED SWITCH GEAR",
    items: [
      {
        id: "check71",
        fieldName: "A: LUBRICATE BEARINGS ON REVERSER WITH BEARING GREASE",
        fieldType: "checkbox",
      },
      {
        id: "check71_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check72",
        fieldName: "B: APPLY VERY LIGHT FILM OF LITHIUM GREASE ON REVERSER CONTACTS AND INSPECT CONDITION OF CONTACTS & SHUNT CABLES",
        fieldType: "checkbox",
      },
      {
        id: "check72_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  15: {
    groupTitle: "PROTECTIVE DEVICES (CHECK OPERATION - REPAIR AS NECESSARY)",
    items: [
      {
        id: "check73",
        fieldName: "A: HOT ENGINE LIGHT AND ALARM BELL",
        fieldType: "checkbox",
      },
      {
        id: "check73_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check74",
        fieldName: "B: WHEEL SLIP LIGHT",
        fieldType: "checkbox",
      },
      {
        id: "check74_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  16: {
    groupTitle: "CONTROL STAND",
    items: [
      {
        id: "check75",
        fieldName: "A: AAR TYPE - INSPECT FOR VISUAL DAMAGE",
        fieldType: "checkbox",
      },
      {
        id: "check75_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check76",
        fieldName: "B: DRUM TYPE - INSPECT FOR VISUAL DAMAGE AND LUBRICATE DRUM CONTACTS WITH A VERY LIGHT FILM OF LITHIUM GREASE.",
        fieldType: "checkbox",
      },
      {
        id: "check76_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  17: {
    groupTitle: "AUX GEN",
    items: [
      {
        id: "check77",
        fieldName: "A: CHECK VOLTAGE & RECORD (70-74 VOLTS)",
        fieldType: "checkbox",
      },
      {
        id: "check77_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "number",
        fieldName: "Voltages",
        fieldType: "number",
      },
      {
        id: "number_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  18: {
    groupTitle: "ENGINE SHUT DOWN DEVICES",
    items: [
      {
        id: "check78",
        fieldName: "A: THROTTLE SHUT-DOWN",
        fieldType: "checkbox",
      },
      {
        id: "check78_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check79",
        fieldName: "B: LO OIL BUTTON (& GOVERNOR SHUT-DOWN LIGHT IF EQUIPPED)",
        fieldType: "checkbox",
      },
      {
        id: "check79_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check80",
        fieldName: "C: ENGINE PROTECTION DEVICE",
        fieldType: "checkbox",
      },
      {
        id: "check80_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check81",
        fieldName: "D: ALL EMERGENCY FUEL TRIPS",
        fieldType: "checkbox",
      },
      {
        id: "check81_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  19: {
    groupTitle: "COOLING FANS & SHUTTERS",
    items: [
      {
        id: "check82",
        fieldName: "A: CHECK OPERATION AND REPAIR AS NECESSARY",
        fieldType: "checkbox",
      },
      {
        id: "check82_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check83",
        fieldName: "B: CHECK V BELTS & PULLIES (LUBE PULLIES AS R'QRD)",
        fieldType: "checkbox",
      },
      {
        id: "check83_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  20: {
    groupTitle: "THROTTLE",
    items: [
      {
        id: "check84",
        fieldName: "A: CHECK THROTTLE LOADING SEQUENCE (FORWARD AND REVERSE)",
        fieldType: "checkbox",
      },
      {
        id: "check84_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check85",
        fieldName: "B: CHECK ENGINE SPEEDS AND OVERSPEED",
        fieldType: "checkbox",
      },
      {
        id: "check85_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  21: {
    groupTitle: "LOAD METER",
    items: [
      {
        id: "check86",
        fieldName: "A: (368 DAYS) CHECK FOR PROPER OPERATION AND CALIBRATE",
        fieldType: "checkbox",
      },
      {
        id: "check86_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  22: {
    groupTitle: "MU RECEPTACLES & JUMPER CABLE(S)",
    items: [
      {
        id: "check87",
        fieldName: "A: VISUAL CHECK FOR DAMAGE",
        fieldType: "checkbox",
      },
      {
        id: "check87_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check88",
        fieldName: "B: CONTINUITY CHECK OF CABLE(S) (8 to 9 & 9 to 8, others 1 to 1 etc.)",
        fieldType: "checkbox",
      },
      {
        id: "check88_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  23: {
    groupTitle: "SPEEDOMETER",
    items: [
      {
        id: "check89",
        fieldName: "A: CHECK FOR OPERATION IF EQUIPPED",
        fieldType: "checkbox",
      },
      {
        id: "check89_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  24: {
    groupTitle: "TRANSITION",
    items: [
      {
        id: "check90",
        fieldName: "A: INSPECT CIRCUIT FOR COMPONENT DAMAGE",
        fieldType: "checkbox",
      },
      {
        id: "check90_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  25: {
    groupTitle: "PRIME MOVER OVERHEAD",
    items: [
      {
        id: "check91",
        fieldName: "A: INSPECT (WHILE RUNNING) FOR FUEL LEAKS, LOOSE OR DAMAGED HARDWARE, AND PROPER OPERATION.",
        fieldType: "checkbox",
      },
      {
        id: "check91_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  26: {
    groupTitle: "COOLING SYSTEM",
    items: [
      {
        id: "check92",
        fieldName: "A: CHECK FOR LEAKS WHILE RUNNING",
        fieldType: "checkbox",
      },
      {
        id: "check92_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  27: {
    groupTitle: "SLOBBER TANK",
    items: [
      {
        id: "check93",
        fieldName: "A: DRAIN AND PROPERLY DISPOSE OF SCRAP OIL",
        fieldType: "checkbox",
      },
      {
        id: "check93_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  28: {
    groupTitle: "FLUID LEVELS (CHECK AND ADD LIQUIDS AS NECESSARY)",
    items: [
      {
        id: "check94",
        fieldName: "A: COMPRESSOR CRANKCASE OIL",
        fieldType: "checkbox",
      },
      {
        id: "check94_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check95",
        fieldName: "B: ENGINE COOLANT (WATER+BORON OR 50/50 DEIONIZED WATER AND PROPYLENE GLYCOL ANTIFREEZE)",
        fieldType: "checkbox",
      },
      {
        id: "check95_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check96",
        fieldName: "C: GOVERNOR OIL",
        fieldType: "checkbox",
      },
      {
        id: "check96_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check97",
        fieldName: "D: PRIME MOVER CRANKCASE OIL",
        fieldType: "checkbox",
      },
      {
        id: "check97_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check98",
        fieldName: "E: FLANGE LUBRICATOR RESERVOIR OIL LEVEL (IF EQUIPPED)",
        fieldType: "checkbox",
      },
      {
        id: "check98_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  29: {
    groupTitle: "Perform air brake maintenance worksheet of this check-off list",
    items: [],
  },
  30: {
    groupTitle: "Perform wheel geometry and misc. clearances worksheet of this check-off list",
    items: [],
  },
  31: {
    groupTitle: "Perform prime mover inspection worksheet (368 days) of this check-off list",
    items: [],
  },
  32: {
    groupTitle: "GOVERNOR LINKAGE",
    items: [
      {
        id: "check99",
        fieldName: "A: INSPECT BEARINGS AND CHECK FOR PROPER OPERATION",
        fieldType: "checkbox",
      },
      {
        id: "check99_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  33: {
    groupTitle: "General Fields",
    items: [
      {
        id: "check100",
        fieldName: "A: GREASE EQUIPMENT PILLOW BLOCK BEARINGS ON TRACTION MOTOR BLOWERS AND ON ANY OTHER APPLICABLE FITTINGS",
        fieldType: "checkbox",
      },
      {
        id: "check100_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check101",
        fieldName: "A: CLEAN OUT EXHAUST CARBON TRAPS & INSPECT FOR EXHAUST LEAKS",
        fieldType: "checkbox",
      },
      {
        id: "check101_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check102",
        fieldName: "A: OBTAIN LUBE OIL SAMPLE",
        fieldType: "checkbox",
      },
      {
        id: "check102_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check103",
        fieldName:
          "A: INSPECT COMPRESSOR DRIVE SHAFT AND COUPLINGS, AUX GEN DRIVE SHAFT AND COUPLINGS, AND DRIVE SYSTEMS FOR TRACTION MOTOR BLOWERS",
        fieldType: "checkbox",
      },
      {
        id: "check103_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  34: {
    groupTitle: "WINDSHIELD WIPERS",
    items: [
      {
        id: "check104",
        fieldName: "A: CHECK OPERATION & REPAIR AS NECESSARY",
        fieldType: "checkbox",
      },
      {
        id: "check104_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check105",
        fieldName: "B: REPLACE ANY WORN BLADES",
        fieldType: "checkbox",
      },
      {
        id: "check105_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  35: {
    groupTitle: "General Fields",
    items: [
      {
        id: "check106",
        fieldName: "A: REPLACE BROKEN GLASS, DAMAGED DECALS, LABELS, & REFLECTIVE TAPE",
        fieldType: "checkbox",
      },
      {
        id: "check106_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check107",
        fieldName: "A: ON KXHR UNITS, MAKE SURE BOTH TENNESSEE AND FEDERAL HAZ MAT TRANSPORT PERMITS ARE IN DATE",
        fieldType: "checkbox",
      },
      {
        id: "check107_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check108",
        fieldName: "A: INSPECT ENVIRONMENTAL KIT (SHOVEL AND ABSORBENTS) STOCK AS NEC.",
        fieldType: "checkbox",
      },
      {
        id: "check108_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check109",
        fieldName: "A: WASH ENGINE ROOM, CAR BODY, AND TRUCKS",
        fieldType: "checkbox",
      },
      {
        id: "check109_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check110",
        fieldName: "A: CHECK CONDITION OF FIRE EXTINGUISHERS AND THAT THEY ARE CHARGED",
        fieldType: "checkbox",
      },
      {
        id: "check110_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check111",
        fieldName: "A: REPLENISH FIRST AID KIT SUPPLIES",
        fieldType: "checkbox",
      },
      {
        id: "check111_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check112",
        fieldName: "A: FILL SAND TANKS",
        fieldType: "checkbox",
      },
      {
        id: "check112_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check113",
        fieldName:
          "A: CHECK STOCK OF SPARE BRAKE PIPE HOSE & WRENCH AND GLAD HAND SEALS (horn valve handle should have at least three seals on it)",
        fieldType: "checkbox",
      },
      {
        id: "check113_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  36: {
    groupTitle: "Air Brake Maintenance Worksheet",
    items: [
      {
        id: "check114",
        fieldName: "Test air brake equipment including testing brake pipe leakage (5psi/min)",
        fieldType: "checkbox",
      },
      {
        id: "check114_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check115",
        fieldName: "Test sanders, horn, and bell",
        fieldType: "checkbox",
      },
      {
        id: "check115_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check116",
        fieldName: "Check for correct air pressure settings, MR, BP, ER, BC, BP portable gauge(s) & Control",
        fieldType: "checkbox",
      },
      {
        id: "check116_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check117",
        fieldName: "Inspect/repair/replace air hoses (8yrs max mu & BP, 15yrs max cyl) & gland hand seals",
        fieldType: "checkbox",
      },
      {
        id: "check117_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check118",
        fieldName: "Check automatic drain valves for proper operation",
        fieldType: "checkbox",
      },
      {
        id: "check118_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check119",
        fieldName: "Drain moisture from main reservoirs, dirt collectors, and filters as applicable",
        fieldType: "checkbox",
      },
      {
        id: "check119_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check120",
        fieldName: "Test main reservoir safety valve",
        fieldType: "checkbox",
      },
      {
        id: "check120_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check121",
        fieldName: "Check brake cylinder piston travel and adjust as necessary",
        fieldType: "checkbox",
      },
      {
        id: "check121_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check122",
        fieldName: "Test all air gauges (+/- 3 PSI)",
        fieldType: "checkbox",
      },
      {
        id: "check122_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check123",
        fieldName: "Check auxiliary emergency brake valve for proper operation & identification",
        fieldType: "checkbox",
      },
      {
        id: "check123_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check124",
        fieldName: "Check main reservoir leakage from 84 psi (not to exceed 3psi/min 3min check)",
        fieldType: "checkbox",
      },
      {
        id: "check124_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check125",
        fieldName: "Check brake cylinder leakage (full service app., must remain applied min 5 minutes)",
        fieldType: "checkbox",
      },
      {
        id: "check125_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check126",
        fieldName: "Check for leaks on control air system and repair as necessary",
        fieldType: "checkbox",
      },
      {
        id: "check126_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check127",
        fieldName: "Check condition of blue card holder",
        fieldType: "checkbox",
      },
      {
        id: "check127_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check128",
        fieldName: "Clean dirt collectors and renew gaskets",
        fieldType: "checkbox",
      },
      {
        id: "check128_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check129",
        fieldName: "Replace all filters in main reservoir system (including dryer assemblies)",
        fieldType: "checkbox",
      },
      {
        id: "check129_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check130",
        fieldName: "Replace automatic drain valves",
        fieldType: "checkbox",
      },
      {
        id: "check130_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check131",
        fieldName: "Replace main reservoir safety valve",
        fieldType: "checkbox",
      },
      {
        id: "check131_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check132",
        fieldName: "Replace intercooler safety valve",
        fieldType: "checkbox",
      },
      {
        id: "check132_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check133",
        fieldName: "Replace brake cylinder relay valve(s)",
        fieldType: "checkbox",
      },
      {
        id: "check133_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check134",
        fieldName: "Replace brake pipe vent valve(s)",
        fieldType: "checkbox",
      },
      {
        id: "check134_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check135",
        fieldName: "Replace reducing and feed valve(s)",
        fieldType: "checkbox",
      },
      {
        id: "check135_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check136",
        fieldName: "Replace all sand control valves",
        fieldType: "checkbox",
      },
      {
        id: "check136_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check137",
        fieldName: "Replace all magnet valves",
        fieldType: "checkbox",
      },
      {
        id: "check137_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check138",
        fieldName: "Replace bell operating valve (G&O REQUIREMENT, NOT FRA)",
        fieldType: "checkbox",
      },
      {
        id: "check138_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check139",
        fieldName: "Replace horn operating valve (G&O REQUIREMENT, NOT FRA)",
        fieldType: "checkbox",
      },
      {
        id: "check139_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check140",
        fieldName: "Replace all one way & double check valves, including 2'' Main reservoir check valve",
        fieldType: "checkbox",
      },
      {
        id: "check140_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check141",
        fieldName: "Replace automatic brake valve",
        fieldType: "checkbox",
      },
      {
        id: "check141_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check142",
        fieldName: "Replace independent brake valve",
        fieldType: "checkbox",
      },
      {
        id: "check142_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check143",
        fieldName: "Replace control valve portions, (service & quick release) or distributing valve",
        fieldType: "checkbox",
      },
      {
        id: "check143_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check144",
        fieldName: "Replace relayair valves",
        fieldType: "checkbox",
      },
      {
        id: "check144_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check145",
        fieldName: "Replace MU2A or rotair valve",
        fieldType: "checkbox",
      },
      {
        id: "check145_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check146",
        fieldName: "Replace A-1 charging cut-off pilot valve",
        fieldType: "checkbox",
      },
      {
        id: "check146_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check147",
        fieldName: "Replace Brake Pipe filter element in cut-off valve assembly under control valve",
        fieldType: "checkbox",
      },
      {
        id: "check147_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check148",
        fieldName: "Clean brake cyls, renew grease, packing cups, strainers, & non-pressure head gaskets",
        fieldType: "checkbox",
      },
      {
        id: "check148_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check149",
        fieldName: "Replace P2A brake application valve",
        fieldType: "checkbox",
      },
      {
        id: "check149_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check150",
        fieldName: "Replace F-1 selector valve",
        fieldType: "checkbox",
      },
      {
        id: "check150_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check151",
        fieldName: "Replace transfer valves",
        fieldType: "checkbox",
      },
      {
        id: "check151_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check152",
        fieldName: "Replace foot valve (dead man's pedal)",
        fieldType: "checkbox",
      },
      {
        id: "check152_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check153",
        fieldName: "Replace equalizing piston portion",
        fieldType: "checkbox",
      },
      {
        id: "check153_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  37: {
    groupTitle:
      "UNITS EQUIPPED WITH 26L BRAKES ONLY REQUIRE THE MAIN RESERVOIR FILTER TO BE CHANGED OUT. Because of the design of different air systems, some line items will not apply to certain locos. Renew all component mounting gaskets when installing.",
    items: [],
  },
  38: {
    groupTitle: "WHEEL GEOMETRY & MISC. CLEARANCES",
    items: [
      {
        id: "tab1",
        fieldName: "POS L",
        fieldType: "table",
        options: [
          {
            id: "text3",
            fieldName: "POS",
            fieldType: "text",
          },
          {
            id: "text4",
            fieldName: "FLNG. HT",
            fieldType: "text",
          },
          {
            id: "text5",
            fieldName: "FLNG. THKNS",
            fieldType: "text",
          },
          {
            id: "text6",
            fieldName: "RIM THKNS",
            fieldType: "text",
          },
          {
            id: "text7",
            fieldName: "TREAD COND.",
            fieldType: "text",
          },
          {
            id: "tab1_filledBy",
            fieldName: "Inspector Name",
            fieldType: "text",
          },
        ],
      },
      {
        id: "tab2",
        fieldName: "POS R",
        fieldType: "table",
        options: [
          {
            id: "text8",
            fieldName: "POS",
            fieldType: "text",
          },
          {
            id: "text9",
            fieldName: "FLNG. HT",
            fieldType: "text",
          },
          {
            id: "text10",
            fieldName: "FLNG. THKNS",
            fieldType: "text",
          },
          {
            id: "text11",
            fieldName: "RIM THKNS",
            fieldType: "text",
          },
          {
            id: "text12",
            fieldName: "TREAD COND.",
            fieldType: "text",
          },
          {
            id: "tab2_filledBy",
            fieldName: "Inspector Name",
            fieldType: "text",
          },
        ],
      },
    ],
  },
  39: {
    groupTitle: "MAXIMUM FLANGE HEIGHT- MUST BE LESS THAN 1 ½'' TO BE IN SERVICE",
    items: [],
  },
  40: {
    groupTitle: "MINIMUM FLANGE THICKNESS - MUST BE GREATER THAN 7/8'' TO BE IN SERVICE",
    items: [],
  },
  41: {
    groupTitle: "MINIMUM RIM THICKNESS - MUST BE GREATER THAN 1'' TO BE IN SERVICE",
    items: [],
  },
  42: {
    groupTitle: "COUPLER HEIGHT",
    items: [
      {
        id: "text13",
        fieldName: "FRONT",
        fieldType: "text",
      },
      {
        id: "text13_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "text14",
        fieldName: "REAR",
        fieldType: "text",
      },
      {
        id: "text14_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  43: {
    groupTitle: "MIN COUPLER HEIGHT IS 31 ½” & MAXIMUM HEIGHT IS 35''",
    items: [],
  },
  44: {
    groupTitle: "PILOT HEIGHT",
    items: [
      {
        id: "text15",
        fieldName: "FRONT",
        fieldType: "text",
      },
      {
        id: "text15_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "text16",
        fieldName: "REAR",
        fieldType: "text",
      },
      {
        id: "text16_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  45: {
    groupTitle: "MINIMUM PILOT HEIGHT IS 3'' AND MAXIMUM PILOT HEIGHT IS 6''",
    items: [],
  },
  46: {
    groupTitle: "SIDE BEARING CLEARANCE",
    items: [
      {
        id: "text17",
        fieldName: "FRONT LEFT",
        fieldType: "text",
      },
      {
        id: "text17_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "text18",
        fieldName: "FRONT RIGHT",
        fieldType: "text",
      },
      {
        id: "text18_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "text19",
        fieldName: "REAR LEFT",
        fieldType: "text",
      },
      {
        id: "text19_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "text199",
        fieldName: "REAR RIGHT",
        fieldType: "text",
      },
      {
        id: "text199_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  47: {
    groupTitle: "MAXIMUM SIDE BEARING CLEARANCE IS ¼''.",
    items: [],
  },
  48: {
    groupTitle: "MINIMUM SIDE BEARING CLEARANCE: NO CONTACT IS ALLOWED",
    items: [],
  },
  49: {
    groupTitle: "PRIME MOVER INSPECTION (368 DAYS)",
    items: [
      {
        id: "tab3",
        fieldName: "CYL",
        fieldType: "table",
        options: [
          {
            id: "text20",
            fieldName: "CYL",
            fieldType: "text",
          },
          {
            id: "text21",
            fieldName: "BORE",
            fieldType: "text",
          },
          {
            id: "text22",
            fieldName: "RINGS",
            fieldType: "text",
          },
          {
            id: "text23",
            fieldName: "PISTON SKIRT",
            fieldType: "text",
          },
          {
            id: "text24",
            fieldName: "PISTON CROWN (wet/dry)",
            fieldType: "text",
          },
          {
            id: "text25",
            fieldName: "P-PIPE",
            fieldType: "text",
          },
          {
            id: "text26",
            fieldName: "PSIG",
            fieldType: "text",
          },
          {
            id: "tab3_filledBy",
            fieldName: "Inspector Name",
            fieldType: "text",
          },
        ],
      },
      {
        id: "check154",
        fieldName: "RETORQUE POWER ASSEMBLY CRAB NUTS",
        fieldType: "checkbox",
      },
      {
        id: "check154_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check155",
        fieldName: "CHECK & ADJUST: TIMING, VALVE LASH, AND RACK",
        fieldType: "checkbox",
      },
      {
        id: "check155_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check156",
        fieldName: "CLEAN LUBE OIL SUCTION STRAINERS-(CHANGE GASKETS)",
        fieldType: "checkbox",
      },
      {
        id: "check156_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check157",
        fieldName: "CLEAN CRANKCASE LUBE OIL SEPARATOR & ENGINE VALLEY",
        fieldType: "checkbox",
      },
      {
        id: "check157_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check158",
        fieldName: "RETORQUE EXHAUST MANIFOLD NUTS AND CLEAN VALLEY",
        fieldType: "checkbox",
      },
      {
        id: "check158_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check159",
        fieldName: "CLEAN ENGINE MOUNTED FUEL OIL SIGHT GLASS AS NEC (CHANGE GASKETS)",
        fieldType: "checkbox",
      },
      {
        id: "check159_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check160",
        fieldName: "CLEAN FUEL TANK SIGHT GLASSES AS NECESSARY (CHANGE GASKETS)",
        fieldType: "checkbox",
      },
      {
        id: "check160_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check161",
        fieldName: "CLEAN EXHAUST SCREEN ON TURBO MODELS",
        fieldType: "checkbox",
      },
      {
        id: "check161_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check162",
        fieldName: "TAP THE PEE PIPES; TAP THE HEADS ON THE UPPER AND LOWER BASKET BOLTS",
        fieldType: "checkbox",
      },
      {
        id: "check162_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
  50: {
    groupTitle: "BLUE CARD",
    items: [
      {
        id: "check163",
        fieldName: "UPDATE",
        fieldType: "checkbox",
      },
      {
        id: "check163_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
      {
        id: "check164",
        fieldName: "PROVIDE COPY TO THE KNOXVILLE LOCOMOTIVE WORKS",
        fieldType: "checkbox",
      },
      {
        id: "check164_filledBy",
        fieldName: "Inspector Name",
        fieldType: "text",
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/LocomotiveCheckOffList/SchemaAndTemplate.jsx